import { useQuery } from '@tanstack/react-query';
import { getProcessedTimesheetStatuses } from '../../Services/ProcessedTimesheetService';

const useGetProcessedTimesheetsStatuses = (options) =>
    useQuery({
        queryKey: ['getProcessedTimesheetStatuses'],
        queryFn: () => getProcessedTimesheetStatuses(),
        staleTime: Infinity,
        ...options,
    });

export default useGetProcessedTimesheetsStatuses;
